export default {
  en: {
    role: 'Role',
  },
};
